import React from 'react';
import PropTypes from 'prop-types';
import SMOSettingMenuView from './SMOSettingMenuView';
import SMOSettingEditAddressFragmentView from './SMOSettingEditAddressFragmentView';
import SMOSettingEditAdminFragmentView from './SMOSettingEditAdminFragmentView';
import SMOSettingEditCalendarFragmentView from './SMOSettingEditCalendarFragmentView';
import SMOSettingEditReviewFragmentView from './SMOSettingEditReviewFragmentView';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMOwnerResource from 'resources/SMOwnerResource';
import reactMixin from 'react-mixin';

class SMOSettingEditView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    this.state = {
      owner: this.props.owner ? this.props.owner.attributes : null,
    };
    this.navigationList = [
      { uid: 'account',
        title: 'dashboard.label_000020',
        path: Routes.owner_dashboard_settings_account_path
      },
      { uid: 'address',
        title: 'dashboard.label_000021',
        path: Routes.owner_dashboard_settings_address_path
      },
      { uid: 'bank_account',
        title: 'dashboard.label_000022',
        path: Routes.owner_dashboard_settings_bank_account_path
      },
      { uid: 'notification',
        title: 'dashboard.label_000023',
        path: Routes.owner_dashboard_settings_notification_path
      },
      { uid: 'admin',
        title: 'dashboard.label_000024',
        path: Routes.owner_dashboard_settings_admin_path
      },
      { uid: 'calendar',
        title: 'dashboard.label_000072',
        path: Routes.owner_dashboard_settings_calendar_path
      },
      { uid: 'review',
        title: 'dashboard.label_000145',
        path: Routes.owner_dashboard_settings_review_path
      }
    ];
  }

  componentDidMount() {
    $('body').addClass('js-split-view');
    window.addEventListener('resize', this.sizeToFit.bind(this), false);

    this.sizeToFit();

    this.addSplitViewModal(this.refs.formContent);

    $(document).on("SMOwnerDidUpdateSuccess", this.ownerDidUpdateSuccess.bind(this));
    $(document).on("SMOwnerDidFailToUpdate", this.ownerDidFailToUpdate.bind(this));

    if (this.props.showMessage) {
      $("#js-split_view-main").showSuccessMessage(I18n.t("dashboard.notice_000001"));
    }

    if (this.props.showFailMessage) {
      $("#js-split_view-main").showFailMessage(I18n.t("dashboard.error_000001"));
    }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);

    $(document).off("SMOwnerDidUpdateSuccess", this.ownerDidUpdateSuccess);
    $(document).off("SMOwnerDidFailToUpdate", this.ownerDidFailToUpdate);
  }

  componentWillReceiveProps(nextProps) {
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  componentDidUpdate(prevProps, prevState) {

  }

  saveFormDidSubmit(form) {
    let formData = new FormData(form);

    SMOwnerResource.updateOwner(this.state.owner.id, formData, {}, (data, error, xhr)=>{
      if (xhr.status == 200) {
        this.setState({owner: data});
        $(document).trigger("SMOwnerDidUpdateSuccess", ['admins', this.state.owner.owners_users]);
        location.href = '/owners/'+this.state.owner.username+'/dashboard/settings/admin/updated';
      } else {
        $(document).trigger("SMOwnerDidFailToUpdate", ['admins', this.state.owner.owners_users, error]);
      }
    });
  }

  sizeToFit(e) {
    let $mainTable = $(this.refs.formContent);

    $mainTable.outerHeight(this.mainTableHeight() - 74);
    this.mainTableFooterSizeToFit();
  }

  ownerDidUpdateSuccess(e, name, value){
    //console.log("success")
  }

  ownerDidFailToUpdate(e, name, value, errors){
    //console.log("fail")
  }

  isCurrentFragment(fragmentName) {
    return this.props.selectedFragment == fragmentName;
  }

  render() {
    let selectedIndex = 0;
    this.navigationList.forEach(function(nav, index) {
      if (this.props.selectedFragment == nav.uid) {
        selectedIndex = index;
        return;
      }
    }, this);
    return (
      <div className="dashboard-container clearfix mb30">
        <SMOSettingMenuView owner={this.state.owner} delegate={this} navigationList={this.navigationList} selectedRowIndex={selectedIndex} />
        <div id="js-split_view-main" ref="formContent" className="dashboard-maincol__right js-scroller">
          <SMOSettingEditAddressFragmentView delegate={this} owner={this.state.owner} isCurrent={this.isCurrentFragment('address')} authenticityToken={this.props.authenticityToken} errors={this.props.errors} />
          <SMOSettingEditAdminFragmentView delegate={this} owner={this.state.owner} isCurrent={this.isCurrentFragment('admin')} />
          <SMOSettingEditCalendarFragmentView delegate={this} owner={this.state.owner} isCurrent={this.isCurrentFragment('calendar')} />
          <SMOSettingEditReviewFragmentView delegate={this} owner={this.state.owner} isCurrent={this.isCurrentFragment('review')} requestHost={this.props.requestHost} />
        </div>
      </div>
    );
  }
}
SMOSettingEditView.propTypes = {
  owner: PropTypes.object.isRequired,
  selectedFragment: PropTypes.string.isRequired,
  showMessage: PropTypes.bool,
  showFailMessage:  PropTypes.bool,
  requestHost: PropTypes.string,
};
reactMixin(SMOSettingEditView.prototype, SMSplitViewMixin);
export default SMOSettingEditView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/settings/SMOSettingEditView.jsx